{
  "title": "Antilife Shell",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level abjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self (10-foot radius)",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "A shimmering barrier extends out from you in a 10-foot radius and moves with you, remaining centered on you and hedging out creatures other than undead and constructs.",
    "The barrier lasts for the duration. The barrier prevents an affected creature from passing or reaching through. An affected creature can cast spells or make attacks with ranged or reach weapons through the barrier.",
    "If you move so that an affected creature is forced to pass through the barrier, the spell ends."
  ],
  "spellLists": ["druid"]
}
